import { useMutation } from '@hooks/reactQuery';

import { checkConfigurationTemplateName } from '@api/configurationTemplates';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IName } from '@interfaces/common/common';
import { IResponseError } from '@interfaces/errors/apiErrors';

import { EUserRoles } from '@enums/common';
import { EErrorCodes } from '@enums/errorCodes';

import { CONFIGURATION_TEMPLATES_CHECK_NAME } from '@constants/queryKeys';

interface IUseMutateConfigurationTemplatesCheckNameReturned {
	isLoadingCheckTemplateName: boolean;
	checkTemplateName: (dto: IName) => Promise<boolean>;
	checkTemplateNameError?: string;
	resetCheckTemplateName: () => void;
}

const useMutateConfigurationTemplatesCheckName = (): IUseMutateConfigurationTemplatesCheckNameReturned => {
	const {
		isLoading,
		mutateAsync,
		error,
		reset,
	} = useMutation<IName, boolean, IResponseError>({
		mutationKey: [CONFIGURATION_TEMPLATES_CHECK_NAME],
		mutationFn: checkConfigurationTemplateName,
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => (
				item.code === EErrorCodes.uniqueName ||
				item.code === EErrorCodes.templateNamePattern ||
				item.code === EErrorCodes.notValidNameLength ||
				item.code === EErrorCodes.templateNameMustBeSize
			))) {
				handleErrorFromMessage(err);
			}
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		checkTemplateName: mutateAsync,
		resetCheckTemplateName: reset,
		checkTemplateNameError: error?.errors.map((item) => item.message).join(' ') || undefined,
		isLoadingCheckTemplateName: isLoading,
	};
};

export default useMutateConfigurationTemplatesCheckName;
